import axios from "axios";
import { PublicCardBase } from "environment";
import { Dispatch, SetStateAction } from "react";
import { ResponseProps } from "types/response";

export const updateCard = (cardId: string, qrcode: string, imgExt: string) =>
  axios.post(
    PublicCardBase +
      `api/revalidate/card?secret=lcard&cardId=${cardId}&qrcode=${qrcode}&imgExt=${imgExt}`
  );

export const updateCardsByTemplate = (templateId: string) =>
  axios.post(
    PublicCardBase +
      `api/revalidate/cards?secret=lcard&templateId=${templateId}`
  );

export const uploadFile = (
  cardId: string,
  file: File,
  data: any,
  setProgress?: Dispatch<SetStateAction<number>>
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("data", JSON.stringify(data.data));

  let config = {
    onUploadProgress: (progressEvent: ProgressEvent) => {
      let percentCompleted = Math.floor(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      if (setProgress) setProgress(percentCompleted);
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return axios.post<ResponseProps>(
    PublicCardBase +
      `api/upload?secret=lcard&id=${cardId}&name=${data.data.fileName}`,
    formData,
    config
  );
};
